import template from './approve_users_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class ApproveUsersHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class ApproveUsersHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new ApproveUsersHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'ApproveUsersHelp',
	dialog_class: ApproveUsersHelpPage,
	template: template,
	template_filename: 'translation/dialogs/approve_users_help',
	provider: 'ps'
};
